import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var GraphIllustration = function GraphIllustration(_a) {
  var className = _a.className,
    _a$color = _a.color,
    color = _a$color === undefined ? 'sapphire' : _a$color,
    otherProps = __rest(_a, ["className", "color"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "GraphIllustration",
    role: "img",
    viewBox: "0 0 112 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "72",
    fill: "none",
    className: classNames('cogs-illustration', 'cogs-themed-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M9 50a2 2 0 0 0 2 2h74a2 2 0 0 0 2-2V10.69c0-1.588-1.761-2.542-3.092-1.676L62.474 22.98a2 2 0 0 1-1.706.228l-26.016-8.405a2 2 0 0 0-1.744.252L9.872 30.865A2 2 0 0 0 9 32.517z",
      opacity: ".3"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      d: "M25 56a2 2 0 0 0 2 2h74a2 2 0 0 0 2-2V23.542c0-1.557-1.7-2.517-3.033-1.713L75.474 36.602a2 2 0 0 1-1.377.258l-26.732-4.667a2 2 0 0 0-1.318.223l-20.02 11.153A2 2 0 0 0 25 45.316z",
      opacity: ".5"
    }), jsx("path", {
      fill: "var(--cogs-decorative--".concat(color, "--400)"),
      fillRule: "evenodd",
      d: "M15 7a2 2 0 0 1 2 2v53h86a2 2 0 1 1 0 4H15a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2",
      clipRule: "evenodd",
      opacity: ".5"
    })]
  }));
};

export { GraphIllustration };
